/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_BeforeInputs */

const en_gc_guides_start_before = /** @type {(inputs: Gc_Guides_Start_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your original file unchanged and choose a working copy. An XLSX workbook can contain formulas, styles, charts and multiple worksheets, so a successful import deserves more than a quick glance. Check a few values that you already know. For a first session, you can also open the budget sample without uploading any file. A desktop browser with a keyboard gives you more room for the ribbon and worksheet.`)
};

const zh_gc_guides_start_before = /** @type {(inputs: Gc_Guides_Start_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保留原始文件，使用副本练习。XLSX 可包含公式、样式、图表和多个工作表，因此导入后应仔细核对，尤其是自己已知的几个数据。初次使用也可以直接打开预算示例。搭配键盘的桌面浏览器能为功能区和工作表提供更多空间。`)
};

/**
* | output |
* | --- |
* | "Keep your original file unchanged and choose a working copy. An XLSX workbook can contain formulas, styles, charts and multiple worksheets, so a successful i..." |
*
* @param {Gc_Guides_Start_BeforeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_before = /** @type {((inputs?: Gc_Guides_Start_BeforeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_BeforeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_before(inputs)
	return zh_gc_guides_start_before(inputs)
});
export { gc_guides_start_before as "gc.guides.start.before" }